import { styled } from '@material-ui/core';

import { GridItem } from '..';

import { Paper } from 'shared/components/paper/Paper';

const padding = 28;
// @ts-expect-error - Material-UI v4 styled component type conflict with React 18
export const StyledPaper = styled(Paper)({
  padding,
});

export const Header = styled('div')({
  padding: `0 ${padding}px`,
});

export const Left = styled(GridItem)(({ theme: { breakpoints } }) => ({
  display: 'flex',
  alignItems: 'center',
  [breakpoints.down('xs')]: {
    flexDirection: 'column',
  },
}));

export const Right = styled(GridItem)({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
});
